import uniq from 'lodash/uniq';
import { FC, memo } from 'react';
import { cn } from '../../utils/cn';
import { ScorecardRow } from './types';
import { useTableContext } from '../table/table-provider';
export const MatchplayDeltaIcon: FC<{
  rowData: ScorecardRow;
  holeIndex: number;
}> = memo(({
  rowData,
  holeIndex
}) => {
  const {
    data
  } = useTableContext<ScorecardRow>();
  const score = rowData.scores[holeIndex];
  const teamColors = uniq(data?.map(x => x.schoolColor).filter(x => x));
  if (typeof score !== 'number') {
    return <div className="h-7 leading-7" />;
  }
  if (score === 0) {
    return <div className="h-7 leading-7">Tied</div>;
  }
  const color = score > 0 ? teamColors[0] : teamColors[1];
  return <div className="w-8 lg:w-9 mx-auto">
        <svg className={cn('w-8 lg:w-9 h-1.5', {
      invisible: score < 0
    })} preserveAspectRatio="none" viewBox="0 0 10 5">
          <path d="M 0 5 L 10 5 L 5 0 Z" fill={color} />
        </svg>
        <div className="w-full h-7 text-center flex items-center justify-center" style={{
      backgroundColor: color
    }}>
          <div className="text-white text-2xs lg:text-xs">{Math.abs(score)}UP</div>
        </div>
        <svg className={cn('w-8 lg:w-9 h-1.5', {
      invisible: score > 0
    })} preserveAspectRatio="none" viewBox="0 5 10 5">
          <path d="M 0 5 L 10 5 L 5 10 Z" fill={color} />
        </svg>
      </div>;
});